<template>
  <div class="gd-card">
    <div class="gd-card__title">
      {{ title }}
      <span class="gd-tag gd-tag--red" v-if="object.driver.inErrorState">Erreur</span>
    </div>
    <div class="gd-card__part">
      <div
        class="gd-card__line"
        v-for="(label, index) in labels"
        :key="`label${label.reference}`"
        v-if="index < labels.length / 2">
        <span class="gd-card__label">{{ label.name }}</span> :
        <span v-if="label.reference" class="gd-card__value">
          {{ formatData(object, label.reference) }}
        </span>
      </div>
    </div>
    <div class="gd-card__part">
      <div
        class="gd-card__line"
        v-for="(label, index) in labels"
        :key="`label${label.reference}`"
        v-if="index >= labels.length / 2">
        <span class="gd-card__label">{{ label.name }}</span> :
        <span v-if="label.reference" class="gd-card__value">
          {{ formatData(object, label.reference) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card',

  props: {
    object: {
      type: Object,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },

  methods: {
    formatData(elmt, targetAttribute) {
      console.log(elmt);
      console.log(targetAttribute);
      const attrArray = targetAttribute.split('.');
      if (attrArray.length > 1) {
        let elmtArbo = elmt;
        for (let i = 0; i < attrArray.length; i += 1) {
          elmtArbo = elmtArbo[attrArray[i]];
        }
        if (!elmtArbo) {
          return 'Non renseigné';
        }
        return elmtArbo;
      }
      if (!elmt[targetAttribute]) {
        return 'Non renseigné';
      }
      return elmt[targetAttribute];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Card.vue